import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Collapse, CardBody, Card } from 'reactstrap';
import Icon from '@mdi/react';
import { mdiChevronLeft, mdiChevronDown } from '@mdi/js';
import { Row, Col } from 'reactstrap';
import './CollapseTable.scss';

interface ICollapseTableProps {
  title: string;
  bodyContainerId: string;
  isOpen: boolean;
  checked: boolean;
  onChange: (e: any) => void;
  titleAdded?: string;
  checkedAdd?: any;
  onChangeAdd?: (e: any) => void;
  showAdded?: boolean;
  children: any;
  value?: string;
  disabled?: boolean;
}

const CollapseTableComponent = (props: ICollapseTableProps) => {
  const [tableIsOpen, setTableIsOpen] = useState(false);

  const {
    title,
    bodyContainerId,
    isOpen,
    checked,
    onChange,
    titleAdded,
    checkedAdd,
    onChangeAdd,
    showAdded,
    children,
    value,
    disabled,
  } = props;

  useEffect(() => {
    if (isOpen) setTableIsOpen(true);
  }, [isOpen]);

  const toggle = () => setTableIsOpen(!tableIsOpen);

  return (
    <div className="collapseTable">
      <Row className="collapseTable-header">
        <Col>
          <input
            data-testid={`${bodyContainerId}-title-checkbox`}
            name="select"
            aria-label={checked ? 'Unselect All' : 'Select All'}
            type="checkbox"
            value={`${value ? value : '1'}`}
            checked={checked}
            onChange={onChange}
            disabled={disabled}
          />
          <button
            data-testid={`${bodyContainerId}-title-button`}
            className="w-100 text-left link nobr pr-2"
            onClick={toggle}
            aria-controls={bodyContainerId}
            aria-expanded={tableIsOpen}
          >
            {title}
          </button>
        </Col>

        {/* // it is row now, will be corrected while developing DownloadProject */}
        {showAdded ? (
          <Col>
            <input
              id="additionalStations"
              name="additionalStations"
              type="checkbox"
              value="1"
              onClick={onChangeAdd}
              checked={checkedAdd}
              onChange={onChangeAdd}
            />
            <label htmlFor="additionalStations" className="text-black">
              {titleAdded}
            </label>
          </Col>
        ) : null}

        {children && children.length > 0 ? (
          <Col className="flex-grow-0">
            <button
              data-testid={`${bodyContainerId}-toggle-button`}
              className="link"
              onClick={toggle}
              aria-controls={bodyContainerId}
              aria-expanded={tableIsOpen}
              aria-label={tableIsOpen ? 'Collapse' : 'Expand'}
            >
              <Icon path={tableIsOpen ? mdiChevronDown : mdiChevronLeft} title="" size={1} color="#005ea2" />
            </button>
          </Col>
        ) : null}
      </Row>
      <Collapse isOpen={tableIsOpen}>
        <Card className="collapse-body-container" id={bodyContainerId}>
          <CardBody className="collapse-body">{children}</CardBody>
        </Card>
      </Collapse>
    </div>
  );
};

export const CollapseTable = observer(CollapseTableComponent);
